// extracted by mini-css-extract-plugin
export default {"mat-tab":"link-tab_mat-tab__UddjM","horizontal-rule":"link-tab_horizontal-rule__NqlZy"};